import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { u as useKeyboardClick } from './utils.js';

const mapyMapmenuItemCss = ":host{display:flex;padding:8px 16px;align-items:center;gap:12px;color:rgba(1, 30, 57, 0.6);font-family:Arial, Helvetica, sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:20px;cursor:pointer;user-select:none}:host(:hover),:host(:focus-visible){background:#f5f6f7}:host(:active){color:rgba(30, 174, 0, 1)}:host(:hover:active){color:rgba(27, 157, 0, 1)}:host(:focus-visible){outline:2px solid currentColor}:host([disabled]){color:rgba(1, 30, 57, 0.12);pointer-events:none}";

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyMapmenuItem_originalTabIndex, _MapyMapmenuItem_cleanup;
const MapyMapmenuItem$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenuItem extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    _MapyMapmenuItem_originalTabIndex.set(this, undefined);
    _MapyMapmenuItem_cleanup.set(this, null);
    this.disabled = false;
  }
  watchPropHandler(newValue) {
    if (newValue) {
      this.hostElement.tabIndex = -1;
    }
    else {
      this.hostElement.tabIndex = __classPrivateFieldGet(this, _MapyMapmenuItem_originalTabIndex, "f");
    }
  }
  connectedCallback() {
    __classPrivateFieldSet(this, _MapyMapmenuItem_cleanup, useKeyboardClick(this.hostElement), "f");
    if (!this.hostElement.hasAttribute('tabindex')) {
      this.hostElement.tabIndex = 0;
    }
    __classPrivateFieldSet(this, _MapyMapmenuItem_originalTabIndex, this.hostElement.getAttribute('tabindex'), "f");
    if (this.disabled) {
      this.hostElement.tabIndex = -1;
    }
  }
  disconnectedCallback() {
    var _a;
    (_a = __classPrivateFieldGet(this, _MapyMapmenuItem_cleanup, "f")) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  get hostElement() { return this; }
  static get watchers() { return {
    "disabled": ["watchPropHandler"]
  }; }
  static get style() { return mapyMapmenuItemCss; }
}, [1, "mapy-mapmenu-item", {
    "disabled": [516]
  }]);
_MapyMapmenuItem_originalTabIndex = new WeakMap(), _MapyMapmenuItem_cleanup = new WeakMap();
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu-item"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu-item":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenuItem$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenuItem = MapyMapmenuItem$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenuItem, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu-item.js.map